import { Flex, FlexProps } from 'component-library/components/layout/Flex';
import { Link } from 'component-library/components/links/Link';
import { Body } from 'component-library/components/typography/Body';
import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, ReactNode } from 'react';

import { DepositAccountAgreement } from './DepositAccountAgreement';

export interface LegalProps extends FlexProps {
  displayDepositAccountDetails?: boolean;
  additionalFootnotes?: ReactNode[];
}

export const Legal: FC<LegalProps> = ({
  displayDepositAccountDetails = true,
  additionalFootnotes,
  ...rest
}) => {
  const data = useStaticQuery(graphql`
    query Legal {
      ...DepositAccountAgreement
    }
  `);

  return (
    <Flex {...rest} column>
      <Body marginBottom={24} variant={1} medium>
        Legal
      </Body>
      <Body variant={5}>
        Retirable, Inc. (&apos;Retirable&apos;) is an SEC registered investment
        advisor. By using this website, you accept our{' '}
        <Link to="/legal/terms-and-conditions" variant={5} inline>
          Terms and Conditions
        </Link>{' '}
        and{' '}
        <Link to="/legal/privacy-policy" variant={5} inline>
          Privacy Policy
        </Link>
        . Retirable provides holistic retirement planning services, which are
        available only to residents of the United States. You must be at least
        18 years of age to become a Retirable Premium user. Nothing on this
        website should be considered an offer, solicitation of an offer, or
        advice to buy or sell securities.
      </Body>
      <Body variant={5}>
        Investing involves risk and past performance is not indicative of future
        results. Increased spending increases the risk of depleting your savings
        and performance is not guaranteed. It is very important to do your own
        analysis before making any decisions based on your own personal
        circumstances.
      </Body>
      <Body variant={5}>
        For more information, see our{' '}
        <Link
          variant={5}
          to="https://adviserinfo.sec.gov/firm/summary/307472"
          inline
        >
          Form ADV Part II
        </Link>{' '}
        and{' '}
        <Link variant={5} to="/legal" inline>
          other disclosures
        </Link>
        .
      </Body>
      <Body variant={5} marginTop={12}>
        Retirable is a financial technology company and is not a bank. Banking
        services provided by Thread Bank, Member FDIC. The Retirable Business 
        Visa® Debit Card is issued Thread Bank pursuant to a license from Visa 
        U.S.A. Inc. and may be used everywhere Visa cards are accepted. FDIC 
        insurance is available for funds on deposit through Thread Bank, Member FDIC. 
        Pass-through insurance coverage is subject to conditions.
      </Body>
      <Body variant={5} marginTop={12}>
        Your deposits qualify up to a maximum of $3,000,000 in FDIC insurance coverage when 
        placed at program banks in the Thread Bank deposit sweep program. Your deposits at 
        each program bank become eligible for FDIC insurance up to $250,000, inclusive of any 
        other deposits you may already hold at the bank in the same ownership capacity. You 
        can access the terms and conditions of the sweep program at 
        <Link variant={5} inline to="https://thread.bank/sweep-disclosure/">https://thread.bank/sweep-disclosure/</Link>{' '}
        and a list of program banks at 
        <Link variant={5} inline to="https://thread.bank/program-banks">https://thread.bank/program-banks/</Link>. 
        Please contact customerservice@thread.bank with questions on the sweep program.
      </Body>
      {displayDepositAccountDetails && <DepositAccountAgreement data={data} />}
      {additionalFootnotes?.map((footnote, idx) => (
        <Body key={idx} variant={5} marginTop={12}>
          {footnote}
        </Body>
      ))}
    </Flex>
  );
};
